import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errText } from "@/lib/api";
import { trackEvent } from "@/lib/gtag";

export const AlertSubscribe = ({ filters = {} }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!valid) {
      toast.error(email.trim() ? "Enter a valid email address" : "Enter your email to get alerts");
      return;
    }
    setBusy(true);
    try {
      await api.post("/alerts", {
        email,
        city: filters.city || null,
        category: filters.category || null,
        listing_type: filters.listing_type || null,
        max_price: filters.max_price ? Number(filters.max_price) : null,
        bedrooms: filters.bedrooms ? Number(filters.bedrooms) : null,
      });
      toast.success("Alert saved. We'll email you when a matching home is listed.");
      trackEvent("alert_subscribed", { event_category: "alerts", city: filters.city || "any" });
      setEmail("");
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  const summary = [
    filters.category ? filters.category : "all categories",
    filters.city || null,
    filters.bedrooms ? `${filters.bedrooms}+ BHK` : null,
    filters.max_price ? `under ₹${Number(filters.max_price).toLocaleString("en-IN")}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <form
      onSubmit={submit}
      className="rounded-2xl border border-border bg-muted/40 p-6 flex flex-col gap-4 sm:flex-row sm:items-end"
      data-testid="alert-subscribe-form"
    >
      <div className="flex-1">
        <p className="flex items-center gap-2 font-display text-lg">
          <BellRing className="h-5 w-5 text-primary" /> Get alerts for this search
        </p>
        <p className="mt-1 text-[13px] text-muted-foreground">
          We'll email you the moment a new property matching <span className="font-semibold">{summary}</span> goes live.
        </p>
      </div>
      <div className="flex w-full gap-3 sm:w-auto">
        <Input
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          className="h-12 w-full rounded-lg sm:w-56"
          data-testid="alert-email-input"
        />
        <Button
          type="submit"
          disabled={busy}
          className="h-12 shrink-0 rounded-lg font-bold hover:brightness-95"
          data-testid="alert-subscribe-btn"
        >
          {busy ? "Saving…" : "Notify me"}
        </Button>
      </div>
    </form>
  );
};

export default AlertSubscribe;
